document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-read-more]')

  sections.forEach((section) => {
    const content = section.querySelector('[data-read-more-content]')
    const toggle = section.querySelector('[data-read-more-toggle]')

    if (!content || !toggle) return

    const setup = () => {
      section.classList.remove('is-collapsible')
      section.classList.remove('is-expanded')
      toggle.hidden = true
      toggle.setAttribute('aria-expanded', 'false')

      const collapsedHeightValue = getComputedStyle(content).getPropertyValue('--read-more-collapsed-height').trim()
      const collapsedHeight = parseInt(collapsedHeightValue, 10)

      if (!collapsedHeight || Number.isNaN(collapsedHeight)) return

      const fullHeight = content.scrollHeight

      if (fullHeight > collapsedHeight + 24) {
        section.classList.add('is-collapsible')
        toggle.hidden = false
      }
    }

    toggle.addEventListener('click', () => {
      const expanded = section.classList.toggle('is-expanded')
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false')
    })

    setup()
    window.addEventListener('resize', setup)
  })
})